














import {Vue, Component} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {FeathersVuexFindAll} from '@/utils';
import {ORDER_STATUS, serviceHeaders} from '@/common';
import VendorBox from '@/components/Views/Vendor/VendorBox.vue';
import VendorDialog from '@/components/Views/Vendor/VendorDialog.vue';
import vendorDefault from '@/instance-defaults/vendorDefault';
import ServiceDialog from '@/components/Views/Purchasables/ServiceDialog.vue';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import DashboardServices from '@/components/Pages/Dashboard/DashboardServices.vue';
import DashboardOrders from '@/components/Pages/Dashboard/DashboardOrders.vue';
@Component({
    components: {
        DashboardOrders,
        DashboardServices,
        ServiceDialog,
        VendorDialog,
        VendorBox,
    },
})
export default class CancellationRequests extends Mixins(UserRoleMixin) {
    public total: number = 0;
    public get active() {
        return this.total > 0;
    }
    public mounted() {
        if (this.total > 0) { return; }
        this.initialize();
    }
    public created() {
        if (this.total > 0) { return; }
        this.initialize();
    }
    public async initialize() {
        const {Order} = this.$FeathersVuex;
        const {total} = await Order.find({
            query: {
                ...this.onQuery(),
                $limit: 0,
            },
        });
        this.total = total;
    }
    public onQuery() {
        return {
            status: [ORDER_STATUS.CANCELLING],
        };
    }
}
